import z from "zod";
import { baseEntitySchema } from "./base";

const optionalEmailSchema = z.preprocess((value) => {
  if (typeof value !== "string") {
    return value;
  }

  const normalizedValue = value.trim();

  if (!normalizedValue) {
    return undefined;
  }

  return normalizedValue;
}, z.string().email().optional());

export const ClientDataSchema = z.object({
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  email: z.string().email(),
  phone: z.string().min(1),
  secondaryPhone: z.string().optional(),
  secondaryEmail: optionalEmailSchema,
  companyName: z.string().optional(),
  type: z.enum(["travel agent", "broker", "private", "family"]).optional(),

});

export type ClientData = z.infer<typeof ClientDataSchema>;
export const clientSchema = baseEntitySchema.extend(ClientDataSchema.shape);
export type Client = z.infer<typeof clientSchema>;
